import { useRef } from 'react';
import { isInProgressStatus } from '../utility/listUploadProgress';

// Remembers whether this page ever saw the upload being processed, so we only
// offer "Refresh" to people who watched it finish (not to someone opening an
// upload that was already complete).
export function useSawInProgress(status?: string | null): boolean {
  const sawInProgress = useRef(false);
  if (isInProgressStatus(status)) {
    sawInProgress.current = true;
  }
  return sawInProgress.current;
}
